import Navbar from "./navbar";
import { useEffect, useState } from "react";
import contactus from "./contactus.webp";
import { Link } from "react-router-dom";
import { productsService } from './services/api/products.service';
function Products() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchCategories = async () => {
            setLoading(true);
            setError(null);
            try {
                const data = await productsService.getAllCategories();
                // Expecting data to be an array of categories
                setCategories(Array.isArray(data) ? data : []);
            } catch (err) {
                setError((err && (err.message || err.error)) || String(err));
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    return (
        <>
            <div className="flex">
                <Navbar />
            </div>

            <div className="mt-20 px-4">
                {loading && (
                    <div className="flex h-40 items-center justify-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" />
                    </div>
                )}

                {error && (
                    <p className="flex h-40 items-center justify-center text-xl text-red-600">{error}</p>
                )}

                {!loading && !error && categories && categories.length > 0 ? (
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mx-2">
                        {categories.map((cat) => (
                            <Link to={`/categories/${cat._id}/products`} key={cat.id}>
                                <div className="relative group">
                                    <img src={`/${cat.image}` || contactus} alt={cat.name} className="w-full h-48 object-cover rounded" />
                                    <div className="absolute inset-0 top-3/4 flex items-center justify-center bg-black/40 text-white text-2xl font-semibold group-hover:bg-black/50">{cat.name}</div>
                                </div>
                            </Link>
                        ))}
                    </div>
                ) : (!loading && !error) && (
                    <p className="flex h-40 items-center justify-center text-2xl text-gray-500">No categories found</p>
                )}
            </div>
        </>
    );
}

export default Products;
